/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import GatewayBackups from './backups/backups.directive';
import GatewayFirewall from './firewall/firewall.directive';
import GatewaySwManagement from './software/sw-management.directive';
import GatewayWirelessModem from './wm/wireless-modem.directive';
import GatewayWanList from './wan/wan-list.directive';
import GatewayFileTransfer from './file-transfer/file-transfer.directive';
import GatewayLogRetrieval from './log-retrieval/log-retrieval.directive';
import GatewayRoutes from './gateway.routes';
import AddGatewayController from './add-gateway.controller';
import GatewayDirective from './gateway.directive';
import GatewayTableConfig from './gateway-table.config';
import SpectrumAnalyzerController from './spectrum-analyzer/spectrum-analyzer.controller';
import SpectralScanController from './spectral-scan/spectral-scan.controller';
import RadioStatisticsController from './radio-statistics/radio-statistics.controller';
import GatewayInfoController from './gateway-info/gateway-info.controller';
import WmFirmwareController from './wm-firmware/wm-firmware.controller';
import GatewayBulkProvisioningController from './bulk-provisioning/bulk-provisioning.controller';
import GatewayDashboardController from './dashboard/dashboard.controller';

export default angular.module('tektelic.gateway', [GatewayBackups, GatewayFirewall, GatewaySwManagement, GatewayWirelessModem, GatewayWanList, GatewayFileTransfer, GatewayLogRetrieval])
    .config(GatewayRoutes)
    .controller('AddGatewayController', AddGatewayController)
    .controller('SpectrumAnalyzerController', SpectrumAnalyzerController)
    .controller('SpectralScanController', SpectralScanController)
    .controller('RadioStatisticsController', RadioStatisticsController)
    .controller('GatewayInfoController', GatewayInfoController)
    .controller('WmFirmwareController', WmFirmwareController)
    .controller('GatewayBulkProvisioningController', GatewayBulkProvisioningController)
    .controller('GatewayDashboardController', GatewayDashboardController)
    .directive('tkGateway', GatewayDirective)
    .factory('gatewayTableConfig', GatewayTableConfig)
    .name;



// WEBPACK FOOTER //
// ./src/app/gateway/index.js